export default __webpack_public_path__ + "static/media/resume.700bc4ec.pdf";